module.exports = __webpack_public_path__ + "static/media/washington-dc-75.86b82b43.jpg";